<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Startup M&A in Japan: Fasten your seatbelts
</h1>	

                <span class="meta"> Posted in March 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/japan-startup-m&a.jpg" alt="">
                </figure>
                
<p>One key component of our investment thesis at Shizen Capital is our view on exit opportunities for early-stage startups in Japan. We believe that Japan has now reached an inflection point, and that corporate M&A for Japanese startups is poised to go intergalactic.</p>
<p>Historically, an IPO has been the most common and viable way for VC-backed startups in Japan to exit. The Mothers market of the Tokyo Stock Exchange (now re-branded as TSE Growth) functions so well that even microcap companies in the $10 million valuation range could go public. This has proven to be a double-edged sword, a topic on which I should probably elaborate in a longer post. (TL;DR: The main benefit accrues to VC funds by providing them a convenient path to exit, but not without drawbacks: such as curtailing ambitions of private companies, creating misalignment risk with IPO preparation service providers, forcing a generation of entrepreneurial founders into becoming public company administrators prematurely, and depriving Japan‘s VCs of the opportunity to learn one of the most important skills of the trade, which is positioning a startup for M&A).</p>
<p>Paradoxically, all of our exits from our Japan funds have been via M&A, including my own personal career high. Although our particular track record in Japan seems to represent an exception, we believe that M&A transactions of Japanese startups is about to increase exponentially. We see three principal drivers at play here: </p>
<p>1. A shift in sentiment among founders</p>
<p>We’re observing an unmistakable shift in perspective among founders in Japan that selling their company via M&A is no longer an admission of failure. If you’re surprised when reading that last bit, I too was surprised myself. One of my innumerable discoveries upon launching my first fund in Japan was how Japanese founders had been educated to view an IPO as their proof of success, and that selling their company to another firm implied that they couldn’t make it. At minimum, M&A was viewed as a Plan B at best.</p>
<p>Fortunately, this attitude is changing. While it’s impossible to pinpoint the specific reasons for this shift in mindset, I suspect a couple of contributing factors. Japan may well have reached a critical mass of startup founders who have pursued the IPO path. These founders now manage listed companies — with all the accompanying obligations of compliance and investor relations that a public listing entails — and they are unhappy in their newfound managerial roles, with daily responsibilities far removed from life as a startup entrepreneur. Anecdotally, we have spoken with a handful of such individuals who have confided in us that they are miserable, that they reminisce nostalgically for the days when they could simply tinker and build in harmony with their intrinsic motivations as “0-to-1” entrepreneurs.</p>
<p>Another potential contributor to the changing perceptions is the increasing number of foreign entrepreneurs in Japan, who do not carry the same emotional baggage related to M&A and are setting the example. </p>
<p>2. A tax break for corporations that acquire domestic startups</p>
<p>As part and parcel of the Japanese government’s startup nation agenda, a new tax policy will grant Japanese corporations a tax break in acquiring domestic startups. Under this new scheme, corporations will be able to deduct 25% of their acquisition price from their taxable income up to ¥5 billion (~ $40 million) per transaction and up to an aggregate of up to ¥12.5 billion (~ $100 million) in tax deductions every year.</p>
<p>This new tax deduction could help surmount the “not-invented-here” syndrome prevalent in many Japanese corporations, who in reality are desperate to complement their laudable in-house innovation efforts with innovation from outside the corporate walls. This has the potential to shake up internal corporate incentives. Once a few initial corporations take advantage of the tax deduction, others will likely follow suit, and increase their own M&A activities in emulation. [Note: there remains a minor issue related to goodwill depreciation but this is under review.] </p>
<p>3. A new macroeconomic paradigm of inflation</p>
<p>Inflation has arrived in Japan too. Although not quite yet as severe as the other G7 countries, Japan has recently printed a 41-year high in inflation at nearly 4.3%. Accordingly, we are detecting a growing sensitivity among corporate executives to this new inflationary environment. With over $3 trillion worth of cash in aggregate on their balance sheets (yes, that’s trillion with a ‘T’), corporate Japan faces an increasingly obvious choice: ramp up investment in long overdue digital transformation, or dither while inflation erodes their capital.</p>
<p>Taken together, we believe that the above factors will drive a virtuous cycle. Increased M&A for early-stage ventures in turn will provide a new generation of founders with a taste of company-building accompanied by modest wealth creation. If the experience of European ecosystems is any guide, this first step will likely motivate a subset of these successful founders to jump back into entrepreneurship and to aim even higher. Others may become early-stage VCs themselves, another boon to a startup ecosystem in which few VCs today possess startup experience.</p>
<p>In our view, this context augurs well for early-stage venture investing in Japan overall.</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

